import { IWidgetCard, IWidgetCardsList } from '@entities/widget-card/model/types';

export const findWidget = ({
    widgetId,
    data,
}: {
    widgetId: string;
    data: IWidgetCardsList[];
}): IWidgetCard => {
    if (!data) {
        return null;
    }
    return data.flatMap((category) => category.widgetsList).find((item) => item.id === widgetId);
};
